module.exports = __webpack_public_path__ + "img/executi.a723455b.svg";